import React from 'react';
import { useModal } from '@ui-library/modal/index';
import { SettingOutlined } from '@ant-design/icons';
import Button from '@ui-library/button';
import { MetaData } from '@ui-library/dynamicSelect';
import ColumnSelectionModal, { ColumnSelectionModalProps } from './ColumnSelectionModal';

interface ColumnSelectionButtonProps extends ColumnSelectionModalProps {
  metadata: MetaData;
}
const ColumnSelectionButton = ({
  defaultValue,
  onSubmit,
  sourceRole,
  resourceRole,
  metadata,
  resources,
  disabled,
}: ColumnSelectionButtonProps) => {
  const modal = useModal();
  const showModal = () =>
    modal.show({
      footer: null,
      content: (
        <ColumnSelectionModal
          resources={resources}
          defaultValue={defaultValue}
          onSubmit={async (columnSelection) => {
            if (onSubmit) {
              await onSubmit(columnSelection);
            }
            modal.close();
          }}
          resourceRole={resourceRole}
          sourceRole={sourceRole}
          metadata={metadata!}
          disabled={disabled}
        />
      ),
      className: 'column_selection_modal__container',
    });

  return (
    <>
      <SettingOutlined className="column_selection_button__cogs" onClick={() => showModal()} />
      <Button
        textPrimary
        className="column_selection_button__text"
        style={{ display: 'none' }}
        onClick={() => showModal()}
        name={`${!disabled ? 'Select' : 'View'} Columns`}
      />
    </>
  );
};

export default ColumnSelectionButton;
